export default "__VITE_ASSET__tStwBBry__"